














































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditFactory from "./edit-factory.vue";
import CreateFactory from "./create-factory.vue";
import Auth from '../../../lib/Judgeauthority';
class PageFactoryRequest extends PageRequest {
  FilterText: string;
}
class PageCompanyRequest{
  cId:Number;
}
@Component({
  components: {EditFactory,CreateFactory },
})
export default class Equipments extends AbpBase {
  pagerequest: PageFactoryRequest = new PageFactoryRequest();
  publicpagerequest: PageFactoryRequest = new PageFactoryRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  showAddButton = false;
  userName: string;
  cId:Number;
  searchInt:number = 0;
  get list() {
    return this.$store.state.factory.list;
  }
  get loading() {
    return this.$store.state.factory.loading;
  }
  pageChange(page: number) {
    this.$store.commit("factory/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("factory/setPageSize", pagesize);
    this.getpage();
  }

  getsearch(){
    this.searchInt = 1;
    this.getpage();
  }
  async getpage() {
    if(this.searchInt == 1){
      this.$store.state.thequipment.currentPage=1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    }
    else
    {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.factory.pageSize;
  }
  get totalCount() {
    return this.$store.state.factory.totalCount;
  }
  get currentPage() {
    return this.$store.state.factory.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区名称",
      key: "fName",
    },
    {
      title: "库区编号",
      key: "number",
    },
    {
      title: "备注",
      key: "remark",
    },
    {
      title: "状态",
      key: "status",
      render: (h, params) => {
        let status = params.row.status;
        if (status == 1) {
          status = "启用";
        } else if (status == 0) {
          status = "停用";
        }
        return h("span", status);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let strupdate = h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("factory/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          );
          //判断是否有修改权限
        if (!Auth.getauthority("Pages.Factorys_Update")) {
          strupdate = null;
        }
         let strdelete = h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "factory/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            "删除"
          );
          //判断是否有删除权限
        if (!Auth.getauthority("Pages.Factorys_Delete")) {
          strdelete = null;
        }
        return h("div", [strupdate, strdelete]);
      },
    },
  ];
  ///根据权限返回列数据
  get filterColumns() {
    if (
      !Auth.getauthority("Pages.Factorys_Update") &&
      !Auth.getauthority("Pages.Factorys_Delete")
    ) {
      return this.columns.filter((col) => col.key !== "Actions");
    }
    return this.columns;
  }
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
   
  }
  
 
 created() {
    this.getuserName();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getpage();
    if (Auth.getauthority("Pages.Factorys_Create")) {
      this.showAddButton = true;
    }
  }
}
